module.exports = __webpack_public_path__ + "static/media/landlord-leasing-house.53d4bf99.png";